import {
  Box,
  Button,
  Checkbox,
  Flex,
  Grid,
  NumberInput,
  Textarea,
} from "@mantine/core";
import { IconCheck } from "@tabler/icons-react";
import { useEffect, useState } from "react";
import {
  repositoryDelivery,
  repositoryMdm,
} from "../../../_base/_const/_constVar";
import { NotificationExtension } from "../../../_base/extension/NotificationExtension";
import { MessageResponse } from "../../../model/MessageResponse";
import { modals } from "@mantine/modals";
import { camelCaseToNormalized, normalizeText } from "./DeliveryPayrollKttc";

interface UpdateDeliveryPayrollWarranty {
  asssignmentDetailId: number;
  distanceEstimated: number;
  isPayroll: boolean;
  note: string;
}

const EditDataView = ({ data, onClose }: { data: any; onClose: any }) => {
  const [dataSubmit, setDataSubmit] = useState<UpdateDeliveryPayrollWarranty>({
    asssignmentDetailId: data?.assignmentDetailId,
    distanceEstimated: data?.modifiedDistance
      ? Number(data?.modifiedDistance) / 1000
      : 0,
    isPayroll: data?.modifiedPayroll,
    note: data?.noteByManager,
  });
  const [daeAttributes, setDaeAttributes] = useState<
    Record<string, number | null>
  >(() => {
    try {
      return data?.daeAttributes ? JSON.parse(data.daeAttributes) : {};
    } catch {
      return {};
    }
  });
  const [dataDeliveryWork, setDataDeliveryWork] = useState<any[]>([]);

  const getDataDeliveryWork = async () => {
    const res = await repositoryMdm.get<MessageResponse<any>>(
      "/api/v1/TblDmDeliveryWork/get-all",
    );

    if (res && res.success) {
      const result = res.data;

      setDataDeliveryWork(
        result
          .filter(
            (item: any) =>
              item.name &&
              item.id &&
              item.active &&
              item.department &&
              item.department?.includes("4"),
          )
          .map((item: any) => ({
            value: String(item.id),
            label: String(item.name),
          })),
      );
    }
  };

  const handleSubmit = async () => {
    const res = await repositoryDelivery.post<MessageResponse<any>>(
      "/api/v1/TblDeliveryAssignment/update-delivery-payroll-for-kttc",
      {
        ...dataSubmit,
        distanceEstimated: dataSubmit.distanceEstimated * 1000,
        employeeId: data?.daeEmployeeId || null,
        daeAttributes: JSON.stringify(daeAttributes),
      },
    );

    if (res && res.success) {
      NotificationExtension.Success("Cập nhật thành công !");
      setTimeout(() => {
        onClose((prev: any) => !prev);
        modals.closeAll();
      }, 1000);
    }
  };

  useEffect(() => {
    getDataDeliveryWork();
  }, []);

  return (
    <Box m={"5px 0px"} w={"50vw"} maw={700}>
      <Grid>
        <Grid.Col span={{ base: 12, md: 6, lg: 6 }}>
          <NumberInput
            label="Số km (đã sửa)"
            placeholder="Nhập số kilomet"
            value={dataSubmit?.distanceEstimated || undefined}
            hideControls
            allowNegative={false}
            suffix=" km"
            decimalScale={0}
            fixedDecimalScale
            onChange={(e) =>
              setDataSubmit((prev) => ({
                ...prev,
                distanceEstimated: Number(e) || 0,
              }))
            }
            onFocus={(event) => event.currentTarget.select()}
          />
        </Grid.Col>
        {Object.keys(daeAttributes).map((key) => {
          const normalizedKey = camelCaseToNormalized(key);
          const matched = dataDeliveryWork.find(
            (item: any) => normalizeText(item.label ?? "") === normalizedKey,
          );
          const label = matched?.label ?? key;

          return (
            <Grid.Col span={{ base: 12, md: 6, lg: 6 }} key={key}>
              <NumberInput
                label={label}
                placeholder="Nhập điểm"
                value={daeAttributes[key] ?? undefined}
                hideControls
                allowNegative={true}
                suffix=" điểm"
                onChange={(e) =>
                  setDaeAttributes((prev) => ({
                    ...prev,
                    [key]: e === "" || e === null ? null : Number(e),
                  }))
                }
                onFocus={(event) => event.currentTarget.select()}
              />
            </Grid.Col>
          );
        })}
        <Grid.Col span={12}>
          <Textarea
            label="Ghi chú"
            placeholder="Nhập ghi chú"
            value={dataSubmit?.note}
            onChange={(e) =>
              setDataSubmit((prev) => ({
                ...prev,
                note: e.target.value,
              }))
            }
          />
        </Grid.Col>
      </Grid>
      <Flex justify={"space-between"} align={"center"} mt={10}>
        <Checkbox
          label={"Tính lương (Đã sửa)"}
          checked={dataSubmit?.isPayroll}
          onClick={() =>
            setDataSubmit((prev) => ({
              ...prev,
              isPayroll: !dataSubmit?.isPayroll,
            }))
          }
        />
        <Button
          leftSection={<IconCheck size={14} />}
          onClick={() => handleSubmit()}
        >
          Xác nhận
        </Button>
      </Flex>
    </Box>
  );
};

export default EditDataView;
